const indices = {
    'Livre 1': {
        'Chapitre 1': {
            '6 & 7': {
                1: 'Le début est parfois la fin.',
                2: 'Avez-vous trouvé les solutions?'
            },
            '8 & 9': {
                1: 'Il y a 5 mots cachés.',
                2: 'Un nombre en toutes lettres se repose à l’horizon.'
            },
            '10 & 11': {
                1: 'Son hurlement retentit à travers le val.',
                2: 'Un double sens dans le texte.'
            },
            '12 & 13': {
                1: 'La musique est la clé.',
                2: 'Avez-vous révisé votre solfège?'
            },
            '14 & 15': {
                1: 'Toutes les pierres ne sont pas des joyaux.',
                2: 'Le gras, c’est la vie. Encore meilleur une fois mélangé.'
            },
            '16 & 17': {
                1: 'Dans les cieux brille la solution.',
                2: 'D’un point à un autre.'
            },
            '18 & 19': {
                1: 'Le renard de feu étend sa toile.',
                2: 'http://www.laclef.online/'
            },
            '20 & 21': {
                1: 'Qui suis-je?',
                2: 'Nul n’est prophète en son pays.'
            },
            '22 & 23': {
                1: 'Quel est le bon?',
                2: 'Tout n’est qu’une question d’axes.'
            },
            '24 & 25': {
                1: 'Maillon après maillon, page après page.',
                2: 'Au bout de la chaîne, la solution.'
            },
            '26 & 27': {
                1: 'La parole des templiers est résolue.',
                2: 'Le renard de feu illumine les mots. Avoir résolu la double page 18/19 est primordial.'
            },
            '28 & 29': {
                1: 'Il faut faire le tour de la question.',
                2: 'Dans l’ombre se cache la réponse.'
            },
            '30 & 31': {
                1: 'Derrière la laideur, la lumière.',
                2: 'L’avocat de César.'
            },
            '32 & 33': {
                1: 'Un jeu d’enfant.',
                2: 'Combien de choses sont à leur place?'
            },
            '34 & 35': {
                1: 'Vous touchez la solution du bout des doigts.',
                2: 'Où l’ai-je déjà vu ce triangle?'
            },
            '36 & 37': {
                1: 'Qui fera le premier pas?',
                2: 'Il faut mettre tout ça en perspective.'
            },
            '38 & 39': {
                1: 'Leur affection se renforce lettre après lettre.',
                2: 'L’eux dans l’eau ne compte que pour un.'
            },
            '40 & 41': {
                1: 'La lueur vous montre le chemin.',
                2: 'Ailleurs brûle la chandelle.'
            },
            '42 & 43': {
                1: 'Le monde est infiniment petit.',
                2: 'Que suis-je?'
            },
            '44 & 45': {
                1: 'Où vais-je?',
                2: 'Il faut creuser encore pour atteindre ce trésor.'
            },
            '46 & 47': {
                1: 'Le nuage vous guidera.',
                2: 'Encore faut-il s’y mettre.'
            }
        },
        'Chapitre 2': {
            '48 & 49': {
                1: 'Méfiez-vous des zones d’ombre.',
                2: 'Sans doute que cette page servira à la fin.'
            },
            '50 & 51': {
                1: 'La première mais pas les suivantes.',
                2: 'Vous avez toute la latitude qu’il vous faut.'
            },
            '52 & 53': {
                1: 'Tout est périodique…',
                2: '…Et il faut prendre en compte les éléments.Avoir résolu la double page 18/19 est un plus. Avoir la bonne heure vous donnera un renard content 🙂'
            },
            '54 & 55': {
                1: 'Les avez-vous tous trouvé?',
                2: 'Même celui qui se cache ailleurs?'
            },
            '56 & 57': {
                1: 'Ca ne devrait pas être ici…',
                2: 'Y en a-t-il d’autres de l’autre monde?'
            },
            '58 & 59': {
                1: 'Ca commence toujours par un #…',
                2: 'La solution vous apparaîtra en allant dans le sens antihoraire! Avoir résolu la double page 18/19 est primordial.'
            },
            '60 & 61': {
                1: 'Dans le vent.',
                2: 'Avez-vous vu la bannière ornée? Avoir résolu la double page 18/19 est primordial.'
            },
            '62 & 63': {
                1: 'L’Arkhè.',
                2: 'Ai-je déjà vu ce symbole quelque part?'
            },
            '64 & 65': {
                1: 'La Gloire du féroce Clanaad.',
                2: 'Le rugissement terrible du guerrier.'
            },
            '66 & 67': {
                1: 'A-t-elle le pouvoir de double vue?',
                2: 'Il faut scinder pour mieux comprendre.'
            },
            '68 & 69': {
                1: 'C’est un véritable labyrinthe.',
                2: 'Avez-vous trouvé le chemin? Avoir résolu la double page 18/19 est primordial.'
            },
            '70 & 71': {
                1: 'Ce sont des armes uniques en leur genre.',
                2: 'Il faut compter avec son sens de l’observation.'
            },
            '72 & 73': {
                1: 'Où suis-je?',
                2: 'L’avez-vous trouvé?'
            },
            '74 & 75': {
                1: 'Il faut les prendre une pièce après l’autre.',
                2: 'D’une pichenette, ils tombent les uns et après les autres.'
            }
        },
        'Chapitre 3': {
            '76 & 77': {
                1: 'Elle est de retour, encore une fois.',
                2: 'Avez-vous de nouveau trouvé les solutions?'
            },
            '78 & 79': {
                1: 'Parfois, il vaut mieux refermer le livre et réfléchir.',
                2: 'Regardez bien la couverture.'
            },
            '80 & 81': {
                1: 'Vous distinguez l’ombre d’une solution.',
                2: 'Allez beaucoup plus loin pour savoir qui elle est.'
            },
            '82 & 83': {
                1: 'Des bâtons et des pierres.',
                2: 'Le numéro de page n’est pas le bon.'
            },
            '84 & 85': {
                1: 'Sa couronne est gravée.',
                2: 'Il faut bien emprunter un virage à 360 degrés. Avoir résolu la double page 18/19 est primordial.'
            },
            '86 & 87': {
                1: 'Voilà un texte bien particulier!',
                2: 'Il ne manque pas quelque chose?'
            }
        },
        'Chapitre 4': {
            '88 & 89': {
                1: 'La fin se rapproche.',
                2: 'Elle ne devrait plus avoir de mystère pour vous.'
            },
            '90 & 91': {
                1: 'Coincée dans son bec.',
                2: 'Cette fleur a bien une signification.'
            },
            '92 & 93': {
                1: 'Un vrai puzzle.',
                2: 'Réunir les petits bouts.'
            },
            '94 & 95': {
                1: 'Le templier face au Clanaad.',
                2: 'Son épée ne vous dit pas quelque chose?'
            },
            '96 & 97': {
                1: 'La suite logique vous amènera au bon endroit.',
                2: 'Ce signe doit être caché là bas.'
            },
            '98 & 99': {
                1: 'Ai-je déjà entendu cette mélodie?',
                2: 'Elle est facile, ne cherchez pas plus loin.'
            },
            '100 & 101': {
                1: 'Même un chiffre commence toujours par une lettre.',
                2: 'Prononcez celle que vous avez trouvée.'
            },
            '102 & 103': {
                1: 'Demandez l’addition.',
                2: 'Encore une histoire de prononciation.'
            },
            '104 & 105': {
                1: 'Baladez-vous un peu.',
                2: 'Retrouvez tous les symboles dans le livre.'
            },
            '106 & 107': {
                1: 'Les particules servent à quelque chose.',
                2: 'Ces formes n’existent-elles pas ailleurs?'
            },
            '108 & 109': {
                1: 'Connaissez-vous ces symboles au loin?',
                2: 'La fin est la solution.'
            },
            '110 & 111': {
                1: 'Une histoire de reflet.',
                2: 'Le nombre doit bien vous aider à quelque chose?'
            },
            '112 & 113': {
                1: 'Il n’est pas trop tard pour rebrousser chemin.',
                2: 'La lampe vous aiguillera alors que vous vous en retournerez.'
            },
            '114 & 115': {
                1: 'A la lumière, les mots apparaissent.',
                2: 'Ceux qui y sont et celui qui n’y est pas.'
            },
            '116 & 117': {
                1: 'La magie est dans le carré.',
                2: 'Qu’est-ce qui se cache sous cette lettre froissée?'
            }
        },
        'Chapitre 5': {
            '118 & 119': {
                1: 'C’est la dernière ligne droite.',
                2: 'On y voit pas grand chose.'
            },
            '120 & 121': {
                1: 'A la croisée des chemins.',
                2: 'La solution est dans le dos.'
            },
            '122 & 123': {
                1: 'La jonction.',
                2: 'Je suis toujours en décalage… Mais de combien?'
            },
            '124 & 125': {
                1: 'ASCII n00b.',
                2: '\/0!|_@   °||_|!   [)€\/|2@!†   @![)€|2'
            },
            '126 & 127': {
                1: 'Je suis déboussolé.',
                2: 'Quel chemin faut-il suivre?'
            },
            '128 & 129': {
                1: 'Des chiffres et des lettres.',
                2: 'Mais quel est le décalage?'
            },
            '130 & 131': {
                1: 'Comment sortir de là?',
                2: 'Comment est mon chemin?'
            },
            '132 & 133': {
                1: 'Ça doit vraiment être important.',
                2: 'Qui suis-je?'
            },
            '134 & 135': {
                1: 'Elles ne font qu’un…',
                2: '… et leur lumière est unique.'
            },
            '136 & 137': {
                1: 'Ce qu’elle est.',
                2: 'Je dois peut-être revenir en arrière.'
            },
            '138 & 139': {
                1: 'Uh oh, je me suis encore perdu.',
                2: 'Où est passée cette maudite page?'
            },
            '140 & 141': {
                1: 'Il faut bien ouvrir les yeux.',
                2: 'Ça vous mènera jusqu’à la solution.'
            },
            '142 & 143': {
                1: 'Encore cette musique entêtante.',
                2: 'Mais où se cache-t-elle?'
            },
            '144 & 145': {
                1: 'Ceci est mon histoire…',
                2: '…Du début jusqu’à la fin.'
            }
        },
    },
    "Livre 2": {
        "Chapitre 1": {
            "8 & 9": {
                1: "Votre voyage commence ici, il est temps de partir explorer la région",
                2: "Le symbole vous aidera à trouver où se trouvent les éléments de réponse"
            },
            "10 & 11": {
                1: "Petit bout par petit bout, vous trouverez la solution",
                2: "Tout un symbole"
            },
            "12 & 13": {
                1: "Suivez la flèche",
                2: "Tout en couleur"
            },
            "14 & 15": {
                1: "Complétement décalé",
                2: "Il faut trouver le bon substitut"
            },
            "16 & 17": {
                1: "Tout est dans la lumière",
                2: "Séparer les éléments vous sera de la plus grande aide"
            },
            "18 & 19": {
                1: "Deux groupes de lettres, une seule solution",
                2: "Sur chacune des deux pages, sa demi solution"
            },
            "20 & 21": {
                1: "Rendez-vous à l'/auberge",
                2: "Avez-vous discuté avec l'homme à droite ?"
            },
            "22 & 23": {
                1: "Trouvez votre chemin dans le labyrinthe",
                2: "Suivez le guide"
            },
            "24 & 25": {
                1: "Attrapez les avant qu'ils ne s'envolent",
                2: "Suivez leur vol"
            },
            "26 & 27": {
                1: "N'avez-vous pas oublié quelque chose à l'auberge ?",
                2: "Commencez par le début et la fin pour trouver"
            }
        },
        "Chapitre 2": {
            "30 & 31": {
                1: "Parfois, il faut savoir fermer le livre pour mieux réfléchir",
                2: "La solution se cache sous vos yeux"
            },
            "32 & 33": {
                1: "Tous à l'abri !",
                2: "Discuter (avec le groupe) vous permettra de trouver la solution"
            },
            "34 & 35": {
                1: "Est-ce un mirage ?",
                2: "N'oubliez pas les paroles"
            },
            "36 & 37": {
                1: "Les nombres vous guideront",
                2: "Que peuvent-ils signifier ?"
            },
            "38 & 39": {
                1: "Dans la longueur",
                2: "Avez-vous trouvé l'autre partie ?"
            },
            "40 & 41": {
                1: "Le retour du maillon faible ?",
                2: "L'écart vous aidera"
            },
            "42 & 43": {
                1: "Triangle et carré vous donneront la solution",
                2: "Des lettres et des lignes"
            },
            "44 & 45": {
                1: "Retournez à l'abri",
                2: "Les autres pages du chapitre vous aideront"
            },
            "46 & 47": {
                1: "Tirez la couverture à vous",
                2: "Où avez-vous vu cette silhouette ?"
            },
            "48 & 49": {
                1: "Recouvrez les visages",
                2: "Derrière se cache la solution"
            },
            "50 & 51": {
                1: "Seule la première reste",
                2: "La solution est capitale"
            },
            "52 & 53": {
                1: "Les épées…",
                2: "…vous mèneront à la révélation"
            },
            "54 & 55": {
                1: "Comme un gros décalage",
                2: "Il faut s'aligner"
            },
            "56 & 57": {
                1: "Sur son visage…",
                2: "… elles coulent"
            },
            "58 & 59": {
                1: "L'écriture est liée",
                2: "Est-ce un simple mandala?"
            },
            "60 & 61": {
                1: "Ces éléments vous rappellent-ils quelque chose?",
                2: "L'abri vous sera d'un grand secours"
            },
            "62 & 63": {
                1: "Il faut tout assembler",
                2: "Une teinte, un élément"
            },
            "64 & 65": {
                1: "Les avez-vous toutes trouvées ?",
                2: "Elles manquent à l'appel"
            }
        },
        "Chapitre 3": {
            "68 & 69": {
                1: "Une énigme très imagée",
                2: "De gauche à droite, elles sont toutes là"
            },
            "70 & 71": {
                1: "Une outre à gauche, une outre à droite, mais différentes",
                2: "Chaque mot compte"
            },
            "72 & 73": {
                1: "Comme les doigts de la main",
                2: "Il faut tout remettre dans l'ordre pour avoir la solution"
            },
            "74 & 75": {
                1: "Il faut remettre de l'ordre",
                2: "Tout n'est que rime"
            },
            "76 & 77": {
                1: "Jeu d'ombres",
                2: "Prêt à prendre son envol"
            },
            "78 & 79": {
                1: "Tout ne tient qu'à un fil",
                2: "Mais par où passe-t-il?"
            },
            "80 & 81": {
                1: "Ça manque de couleur",
                2: "Tel un arc-en-ciel"
            }
        },
        "Chapitre 4": {
            "84 & 85": {
                1: "Suivez la musique",
                2: "Il manque le QR code, non?"
            },
            "86 & 87": {
                1: "Sur un fil…",
                2: "… tout sera aligné"
            },
            "88 & 89": {
                1: "On commence par le début et on finit par la fin",
                2: "Dans l'ordre, ce sera plus simple"
            },
            "90 & 91": {
                1: "INDICE³",
                2: "Tout est dans la forme"
            },
            "92 & 93": {
                1: "Bleue est la solution",
                2: "Parfois, il faut savoir ne faire les choses qu'à moitié"
            },
            "94 & 95": {
                1: "Prenez les choses par le bout…",
                2: "… et revenez vers la gauche"
            }
        },
        "Chapitre 5": {
            "98 & 99": {
                1: "Où avez-vous vu ces statues ?",
                2: "A chaque constellation, sa part"
            },
            "100 & 101": {
                1: "Le code Sans-visage vous sera nécessaire",
                2: "Il faut faire le lien"
            },
            "102 & 103": {
                1: "Sur quel site sont stationnées les troupes",
                2: "Chaque pièce est nécessaire"
            },
            "104 & 105": {
                1: "Ou rose ou bleu, les deux vous mèneront à la solution",
                2: "Mais l'un exclu l'autre"
            },
            "106 & 107": {
                1: "Il faut trouver la cible",
                2: "Elle est au centre de tout"
            },
            "108 & 109": {
                1: "Comme à chaque fois, la solution est au début du chapitre",
                2: "Mais comment pourriez-vous l'identifier ?"
            },
            "110 & 111": {
                1: "Elles gravitent autour de la créature",
                2: "Dans le chapitre vous trouverez la solution"
            },
            "112 & 113": {
                1: "Avez-vous déjà vu ces symboles ?",
                2: "C'est en ordre"
            },
            "114 & 115": {
                1: "De retour à la garnison",
                2: "Tout est relié"
            }
        },
        "Chapitre 6": {
            "118 & 119": {
                1: "Une solution à la carte",
                2: "Le code sans-visage vous sera d'une grande aide"
            },
            "120 & 121": {
                1: "La solution se cache sur le site",
                2: "Il faudrait un peu d'animation"
            },
            "122 & 123": {
                1: "Vous êtes invité à ma table mais mon nom est caché dans les roses",
                2: "Avez-vous trouvé ce que les pages ont en commun ?"
            },
            "124 & 125": {
                1: "Il faut de la suite et de la logique",
                2: "Tout est additif"
            },
            "126 & 127": {
                1: "Vous êtes mandé dans la salle du trône",
                2: "Avez-vous entendu les rumeurs de la cour ?"
            },
            "128 & 129": {
                1: "Il est temps de tout réunir",
                2: "La solution est pointue"
            },
            "130 & 131": {
                1: "Sous les alcôves du palais se révèlent les secrets d'Est-Rive",
                2: "Avez-vous écouté les rumeurs ?"
            },
            "132 & 133": {
                1: "Le reflet de la solution",
                2: "Regardez dans le miroir"
            }
        },
        "Chapitre 7": {
            "136 & 137": {
                1: "Quand le sage montre la lune…",
                2: "Il est parfois bon de la regarder"
            },
            "138 & 139": {
                1: "Les pointes montrent l'arrivée… Trouvez le départ",
                2: "Sous la rose jaune, vous trouverez la dernière partie"
            },
            "140 & 141": {
                1: "Avez-vous trouvé tous les mots ?",
                2: "Dans tout le chapitre 7 et bien à l'abri, ils se cachent"
            },
            "142 & 143": {
                1: "Il suffit de trouver le sens",
                2: "Le monde à l'envers"
            },
            "144 & 145": {
                1: "Rassemblez les couronnes",
                2: "Faites le tour du livre"
            },
            "146 & 147": {
                1: "Il faut marquer des points",
                2: "Mais jamais plus que demandé"
            },
            "148 & 149": {
                1: "La rose est à l'abri",
                2: "C'est enfin le moment d'utiliser cet élément omniprésent !"
            }
        }
    }



};

export default indices;
